<template>
  <span>Something went wrong, your username or password are incorrect</span>
</template>

<script>
  export default {
    name: 'login-failed-template'
  }
</script>